// axios
import axios from 'axios'

const domain = process.env.VUE_APP_API_URL

export default axios.create({
  baseURL: `${domain}api/v1`
})
